<template>
  <div>
    <common-dialog
      ref="dialog"
      width="550px"
      :show-save-button="true"
      unit="账户管理"
      id-key="AccountId"
      :data="data"
      form-label-width="66px"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      close-on-saved
      :form-rules="rules"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
      @closed="reset"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="卡号" prop="CardNumber">
              <el-input v-model="data.CardNumber" size="mini" type="number" placeholder="请填写卡号" ref="cardInp" v-if="!isEdit"></el-input>
              <span style="font-size:13px;padding-left: 5px;" v-else>{{data.CardNumber}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="学号" prop="StudentNumber">
              <el-input v-model="data.StudentNumber" size="mini" placeholder="请选择" @focus="selectSt"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12" v-if="isEdit">
            <el-form-item label="姓名" prop="FullName">
              <span style="font-size:13px;padding-left: 5px;">{{data.FullName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="状态">
              <el-select size="mini" v-model="data.Status" style="width:100%;">
                <el-option :value="1" label="有效"/>
                <el-option :value="0" label="失效"/>
                <el-option :value="2" label="挂失"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <!-- <template slot="footer">
        <el-button @click="toSave(false)" type="danger" size="mini">退 款</el-button>
        <el-button @click="toSave(true)" type="primary" size="mini">保 存</el-button>
        <el-button @click="close" size="mini">取 消</el-button>
      </template> -->
    </common-dialog>
    <st-dialog ref="stDialog" in-dialog selectable :multiple="false" @select="setST" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import stDialog from "@/components/st/student/listDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    stDialog
  },
  data() {
    return {
      data: {
        AccountId: 0,
        StudentId: 0,
        StudentNumber: "",
        FullName: "",
        CardNumber: "",
        Status: 1
      },
      isEdit: false,
      api: require("@/api/consume/account").default,
      isMB: this.$store.state.isMB,
      rules: {
        StudentNumber: [{ required: true, message: "请选择学号" }],
        CardNumber: [{ required: true, message: "请填写卡号" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.$refs.cardInp.focus();
    },
    selectSt() {
      this.$refs.stDialog.open().then((that) => {
        that.getData({});
      });
    },
    setST(st) {
      console.log(st)
      this.data.CardNumber = st.CardNumber
      this.data.FullName = st.FullName
      this.data.StudentNumber = st.StudentNumber
      this.data.StudentId = st.StudentId
    },
    onEditOpened(row) {
      this.isEdit = true;
    },
    onBeforeSave() {
    },
    reset() {
      this.isEdit = false;
    },
  },
};
</script>
<style lang="scss">
</style>